import { EmptyState as CommonEmptyState, EmptyStateProps } from "./common/EmptyState";

export function LoadingState({ label = "Loading" }: { label?: string }) {
  return (
    <div className="state-panel" role="status">
      <span className="loader" />
      <span>{label}</span>
    </div>
  );
}

export function ErrorState({ message }: { message: string }) {
  return (
    <div className="state-panel state-panel-error" role="alert">
      <strong>Something needs attention.</strong>
      <span>{message}</span>
    </div>
  );
}

export function EmptyState({
  title,
  body,
  description,
  ...rest
}: {
  title: string;
  body?: string;
  description?: string;
} & Partial<EmptyStateProps>) {
  return (
    <CommonEmptyState
      title={title}
      description={description || body || ""}
      {...rest}
    />
  );
}

